module.exports = __webpack_public_path__ + "img/bg-2_mobile_word.187f859a.jpg";